import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f3f4f6;
  border-bottom: 1px solid #d1d5db;
  color: #4b5563;
  font-size: 14px;
`;

export const ToolbarButtons = styled.div`
  display: flex;
  gap: 16px;

  span {
    cursor: pointer;
    &:hover {
      color: black;
    }
  }
`;

export const WordCount = styled.p`
  text-align: right;
  color: #6b7280;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 200px;
  padding: 10px;
  border: none;
  outline: none;
  font-size: 14px;
  resize: none;
`;
